import type { Editor } from 'platejs'

import type { BufferEditor } from './types.plate'

/**
 * Thin wrapper kept for call-site stability — v42's `editor.tf.withoutSaving`/
 * `withoutMerging` are already bound to the concrete editor instance, so
 * there's no separate `THistoryEditor` parameter type to satisfy here (unlike
 * the pre-v42 free functions this used to bridge to).
 */
export const withoutSavingHistory = (editor: Editor, fn: () => void): void =>
  (editor as BufferEditor).tf.withoutSaving(fn)

export const withoutMergingHistory = (editor: Editor, fn: () => void): void =>
  (editor as BufferEditor).tf.withoutMerging(fn)
